// src/pages/expense/cafe/ExpenseCafeGreenDraftPreviewWindow.jsx
// ✅ 전 사업 확산 [5] — 카페인 그린점 통합 작성 페이지의 PDF 미리보기 전용 창(팝업).
// 실제 로직은 pages/expense/_shared/ExpenseDraftPreviewWindow.jsx(공통 컴포넌트)에
// 있고, 이 파일은 그린점 전용 config를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import ExpenseDraftPreviewWindow from "../_shared/ExpenseDraftPreviewWindow";
import greenDraftConfig from "./greenDraftConfig";

export default function ExpenseCafeGreenDraftPreviewWindow() {
  return <ExpenseDraftPreviewWindow config={greenDraftConfig} />;
}
